/* eslint-disable import/prefer-default-export */

import { Plugins } from '@leverege/plugin';
export function getMethodsFor(projectSettings) {
  const filter = plg => {
    if (!projectSettings || !projectSettings.supportedProtocols) {
      return plg.canBeActivated !== false;
    }
    return projectSettings.supportedProtocols[plg.type] && plg.canBeActivated !== false;
  };
  return Plugins.createView('TwoFactorAuthMethod', {
    filter
  }).get();
}